import './index.scss';

import Cookies from 'js-cookie';

import {
    createAutoplayVimeoIframe,
    createAutoplayYouTubeIframe,
    playHtmlVideoInLightbox,
} from '../../molecules/fs-lightbox/video';

class VideoTeaser {
    constructor(root) {
        this.root = root;
        this.type = this.root.dataset.videoType;
        this.code = this.root.dataset.videoCode;
        this.mp4 = this.root.dataset.videoMp4;
        this.consentIntro = this.root.dataset.consentIntro || '';
        this.consentAgree = this.root.dataset.consentAgree || '';
        this.consentPrivacyLink = this.root.dataset.consentPrivacyLink || '';
        this.consentPrivacyHref = this.root.dataset.consentPrivacyHref || '/datenschutzerklaerung';
        this.consentButton = this.root.dataset.consentButton || '';
        this.lightboxClose = this.root.dataset.lightboxClose || 'Close';
        this.popup = null;

        this.root.querySelectorAll('[data-videoteaser-play]').forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                this.open();
            });
        });
    }

    open() {
        if (['vimeo', 'youtube'].includes(this.type) && this.code) {
            this.openEmbeded();
        } else if (this.type === 'upload' && this.mp4) {
            this.openUploaded();
        }
    }

    openEmbeded() {
        if (this.getCookie(this.type)) {
            if (this.type === 'vimeo') { this.openVimeo(); }
            if (this.type === 'youtube') { this.openYouTube(); }
        } else {
            this.openConfirm();
        }
    }

    openUploaded() {
        this.openPopup(this.mp4, { autoplayVideo: true });
    }

    openConfirm() {
        const confirm = document.createElement('div');
        confirm.classList.add('videoembed-confirm');
        confirm.classList.add('frame-light-2');

        const content = document.createElement('div');
        content.classList.add('content');

        const richtext = document.createElement('div');
        richtext.classList.add('richtext');

        const intro = document.createElement('p');
        intro.textContent = this.consentIntro.replace(
            '{provider}',
            this.getNameByType(this.type)
        );
        richtext.appendChild(intro);

        const agree = document.createElement('p');
        agree.appendChild(document.createTextNode(this.consentAgree + ' '));

        const privacyLink = document.createElement('a');
        privacyLink.href = this.consentPrivacyHref;
        privacyLink.textContent = this.consentPrivacyLink;
        agree.appendChild(privacyLink);
        richtext.appendChild(agree);

        content.appendChild(richtext);

        const buttongroup = document.createElement('div');
        buttongroup.classList.add('buttongroup');

        const button = document.createElement('button');
        button.type = 'button';
        button.classList.add('button');
        button.classList.add('button--primary');
        button.textContent = this.consentButton;
        button.addEventListener('click', () => {
            this.setCookie(this.type, true);

            this.popup.close();
            this.popup = null;

            this.openEmbeded();
        });

        buttongroup.appendChild(button);
        content.appendChild(buttongroup);
        confirm.appendChild(content);

        this.openPopup(confirm);
    }

    openVimeo() {
        this.openPopup(createAutoplayVimeoIframe(this.code));
    }

    openYouTube() {
        this.openPopup(createAutoplayYouTubeIframe(this.code));
    }

    openPopup(source, { autoplayVideo = false } = {}) {
        this.popup = new FsLightbox();
        this.popup.props.sources = [source];

        if (autoplayVideo) {
            // Skip FsLightbox XHR type detection so <video> exists before onOpen.
            this.popup.props.types = ['video'];
            this.popup.props.onOpen = () => {
                playHtmlVideoInLightbox(this.popup);
            };
        }

        this.popup.open();

        const container = this.popup.elements.container;
        container.classList.add('wf-fslightbox-container');

        const close = document.createElement('button');
        close.type = 'button';
        close.classList.add('wf-fslightbox-close');
        close.setAttribute('aria-label', this.lightboxClose);
        close.appendChild(this.createCloseIcon());
        close.addEventListener('click', () => {
            this.popup.close();
            this.popup = null;
        });

        container.appendChild(close);
    }

    createCloseIcon() {
        const ns = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('width', '28');
        svg.setAttribute('height', '28');
        svg.setAttribute('viewBox', '0 0 28 28');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('aria-hidden', 'true');

        const path1 = document.createElementNS(ns, 'path');
        path1.setAttribute('d', 'M2 26L26 2.00002');
        path1.setAttribute('stroke', 'currentColor');
        path1.setAttribute('stroke-width', '3');
        path1.setAttribute('stroke-linecap', 'round');

        const path2 = document.createElementNS(ns, 'path');
        path2.setAttribute('d', 'M2 2L26 26');
        path2.setAttribute('stroke', 'currentColor');
        path2.setAttribute('stroke-width', '3');
        path2.setAttribute('stroke-linecap', 'round');

        svg.appendChild(path1);
        svg.appendChild(path2);

        return svg;
    }

    setCookie(name, value) {
        Cookies.set(name, value ? 'true' : 'false', { expires: 90 });
    }

    getCookie(name) {
        return Cookies.get(name) === 'true';
    }

    getNameByType(type) {
        if (type === 'vimeo') { return 'Vimeo'; }
        if (type === 'youtube') { return 'YouTube'; }

        return '';
    }
}

window.app.run(() => {
    document.querySelectorAll('[data-videoteaser]').forEach((node) => {
        new VideoTeaser(node);
    });
});
